import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import { FaSignOutAlt, FaUser } from 'react-icons/fa';
import Dropdown from '../../components/Dropdown';

const Header = ({ title = 'Dashboard' }) => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const initials = currentUser?.full_name
    ? currentUser.full_name.charAt(0).toUpperCase()
    : '?';

  return (
    <header
      className="z-10 flex items-center justify-between px-5 h-[52px] shrink-0 relative"
      style={{
        backgroundColor: 'rgba(13,14,30,0.96)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        boxShadow: '0 1px 0 rgba(0,0,0,0.5)',
      }}
    >
      {/* Brand line bottom */}
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, #DC1F26 0%, #3B82F6 60%, #00C2FF 100%)',
          opacity: 0.35,
        }}
      />

      {/* Título animado */}
      <div className="flex-1 ml-10 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.h1
            key={title}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
            className="text-sm font-semibold hidden md:block"
            style={{ color: '#E8EAF0' }}
          >
            {title}
          </motion.h1>
        </AnimatePresence>
      </div>

      {/* Perfil */}
      <div className="flex items-center gap-2">
        <Dropdown
          trigger={
            <div
              className="flex items-center gap-2.5 cursor-pointer px-2 py-1.5 rounded-lg transition-all duration-150"
              style={{ color: '#9BA3B8' }}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.04)'}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
            >
              <span className="text-sm hidden md:block select-none" style={{ color: '#9BA3B8' }}>
                {currentUser?.full_name}
              </span>
              <motion.div
                className="h-8 w-8 rounded-full flex items-center justify-center text-white text-sm font-semibold select-none"
                animate={{ boxShadow: ['0 0 10px rgba(220,31,38,0.45)', '0 0 18px rgba(220,31,38,0.7)', '0 0 10px rgba(220,31,38,0.45)'] }}
                transition={{ duration: 2.5, repeat: Infinity, ease: 'easeInOut' }}
                style={{ backgroundColor: '#DC1F26' }}
              >
                {initials}
              </motion.div>
            </div>
          }
          items={[
            {
              label: 'Mi perfil',
              icon: <FaUser size={13} style={{ color: '#5A6278' }} />,
              onClick: () => navigate('/profile'),
            },
            {
              label: 'Cerrar sesión',
              icon: <FaSignOutAlt size={13} style={{ color: '#DC1F26' }} />,
              onClick: logout,
            },
          ]}
          position="bottom-right"
        />
      </div>
    </header>
  );
};

export default Header;
